// ==================== LOGICA CONFIGURAZIONE MACCHINA ====================
//
// Funzione pura che calcola la configurazione di una macchina spelafili
// a partire dai dati di un cavo multipolare.

import { MACHINES, DEFAULT_MACHINE } from '../constants/machineConstants';
import { TERMINAL_DATA } from '../constants/terminalConstants';

/**
 * Calcola la configurazione completa della macchina per un cavo multipolare.
 *
 * @param {string} machineId - ID della macchina (es. 'EW-05')
 * @param {Object} cable - Cavo multipolare con .poli[], .lunghezza
 * @param {Object} terminalData - Override per TERMINAL_DATA (opzionale)
 * @returns {{ machineId: string, machineName: string, sections: Array }} | null
 */
export const computeMachineConfig = (machineId = DEFAULT_MACHINE, cable, terminalData = TERMINAL_DATA) => {
    const machine = MACHINES[machineId];
    if (!machine) return null;

    const isMultipolar = cable && cable.poli && Array.isArray(cable.poli) && cable.poli.length > 0;
    if (!isMultipolar) return null;

    const sections = machine.computeSections(cable, terminalData);

    return {
        machineId: machine.id,
        machineName: machine.name,
        machineDescription: machine.description,
        sections
    };
};
